const widgetPopout = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M11.05 4.073 9.186 2.2H14v4.84l-1.863-1.873-5.049 5.077L6 9.15zM4.2 11.98h8.9v1.72H2.5V2.9h1.7z"/></svg>',
};

export { widgetPopout as default };
